import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import styles from "../css/Page.module.css";
import data from "../Data";

function Crew() {
  return (
    <div className={styles.container}>
      <Header />
      <div className={styles.content}>
        <h1 className={styles.title}>Crew</h1>
        <p className={styles.text}>
          Meet our dedicated team of professionals who work behind the scenes to ensure every event runs flawlessly.
        </p>
        <div className={styles.crewList}>
          {data.CrewMembers.map((member, index) => (
            <div key={index} className={styles.crewCard}>
              <h3 className={styles.crewTitle}>{member.title}</h3>
              <h2 className={styles.crewName}>{member.name}</h2>
            </div>
          ))}
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Crew;

